module.exports = __webpack_public_path__ + "static/img/bcg.53f81659.webp";